import { Box, BoxProps } from "@mui/material";
import { ReactNode } from "react";

interface FlexContainerProps extends Omit<BoxProps, 'children'> {
  children: ReactNode;
  gap?: number;
}

export function FlexContainer({ children, gap = 1, sx, ...props }: FlexContainerProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap,
        '& > :first-of-type': {
          flex: '1 1 auto',
          minWidth: 0,
          justifyContent: 'flex-start'
        },
        '& > :last-child': {
          flex: '0 0 auto',
          justifyContent: 'flex-end'
        },
        ...sx
      }}
      {...props}
    >
      {children}
    </Box>
  );
}